import React, { useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import InputName from "../../common/Input/InputName";
import InputEmail from "../../common/Input/InputEmail";
import InputNumber from "../../common/Input/InputPhNumber";
import InputAdhar from "../../common/Input/InputAdhar";
import InputPassport from "../../common/Input/InputPassport";
import InputPINCode from "../../common/Input/InputPinCode";
import InputDobOrAge from "../../common/Input/InputDobOrAge";
import Select from "react-select";
import InputImage from "../../common/Input/InputImage";
import InputText from "../../common/Input/InputText";
import { getCountrySlice } from "../../../store/slices/countrySlice";
import { getStateSlice } from "../../../store/slices/state";
import { getDistricSlice } from "../../../store/slices/districtSlice";
import { getCitySlice } from "../../../store/slices/citySlice";

const getPrefillAadharNumber = (details, fallbackAadharNumber) =>
  fallbackAadharNumber ||
  details?.aadhar_number ||
  details?.aadhaarNumber ||
  details?.aadhaar ||
  details?.aadhar ||
  "";

const getPrefillAbhaNumber = (details) =>
  details?.ABHANumber ||
  details?.abhaNumber ||
  details?.abha_number ||
  details?.healthIdNumber ||
  "";

const getPrefillAbhaAddress = (details) =>
  details?.preferredAbhaAddress ||
  details?.abhaAddress ||
  details?.ABHAAddress ||
  details?.phrAddress ||
  details?.healthId ||
  "";

const AddUpdateModal = ({
  setModalVisible,
  resetForm,
  modalVisible,
  formData,
  userDetails,
  handleChange,
  handleAddPatient,
  bloodGroupOptions,
  membershipOptions,
  genderOptions,
  handleSelectChange,
  cities,
  isUpdateMode,
  Country,
  state,
  handleFileChange,
  setInputError,
  setFormData,
  districts,
  token,
  dispatch,
  aadharNumber,
  setFieldErrors,
  fieldErrors,
}) => {
  useEffect(() => {
    const prefillForm = async () => {
      if (!userDetails) return;

      const dob = userDetails?.dob
        ? new Date(userDetails.dob).toISOString().split("T")[0]
        : userDetails.yearOfBirth &&
            userDetails.monthOfBirth &&
            userDetails.dayOfBirth
          ? new Date(
              `${userDetails.yearOfBirth}-${String(
                userDetails.monthOfBirth,
              ).padStart(2, "0")}-${String(userDetails.dayOfBirth).padStart(
                2,
                "0",
              )}`,
            )
              .toISOString()
              .split("T")[0]
          : "";

      const calculateAge = (dob) => {
        if (!dob) return { year: "", month: "", day: "" };
        const birthDate = typeof dob === "string" ? new Date(dob) : dob;
        const now = new Date();
        let years = now.getFullYear() - birthDate.getFullYear();
        let months = now.getMonth() - birthDate.getMonth();
        let days = now.getDate() - birthDate.getDate();
        if (days < 0) {
          months--;
          days += new Date(now.getFullYear(), now.getMonth(), 0).getDate();
        }
        if (months < 0) {
          years--;
          months += 12;
        }
        return { year: years, month: months, day: days };
      };

      setFormData((prev) => ({
        ...prev,
        name:
          userDetails.name ||
          `${userDetails.firstName || ""} ${userDetails.middleName || ""} ${
            userDetails.lastName || ""
          }`.trim(),
        gender:
          userDetails.gender === "M"
            ? "Male"
            : userDetails.gender === "F"
              ? "Female"
              : userDetails.gender === "O"
                ? "Other"
                : "",
        phone:
          userDetails.phone ||
          userDetails.mobile ||
          userDetails.mobileNumber ||
          "",
        email: userDetails.email || "",
        dob,
        age: calculateAge(dob),
        pin: userDetails.pincode || userDetails.pinCode || "",
        address: userDetails.address || "",
        aadhar_number: getPrefillAadharNumber(userDetails, aadharNumber),
        patient_image:
          userDetails.patient_image || userDetails.profilePhoto || "",
        abhaNumber: getPrefillAbhaNumber(userDetails),
        abhaAddress: getPrefillAbhaAddress(userDetails),
      }));

      try {
        const countryRes = await dispatch(getCountrySlice({ token })).unwrap();
        const matchedCountry = countryRes?.result?.list?.find(
          (c) =>
            c.name.toLowerCase().trim() ===
            (userDetails.countryName || "India").toLowerCase().trim(),
        );

        if (!matchedCountry) return;
        setFormData((prev) => ({
          ...prev,
          country: matchedCountry._id,
          countryName: matchedCountry.name,
        }));

        const stateRes = await dispatch(
          getStateSlice({ token, countryId: matchedCountry._id }),
        ).unwrap();
        const matchedState = stateRes?.result?.list?.find(
          (s) =>
            s.name.toLowerCase().trim() ===
            userDetails?.stateName?.toLowerCase().trim(),
        );

        if (!matchedState) return;
        setFormData((prev) => ({
          ...prev,
          state: matchedState._id,
          stateName: matchedState.name,
        }));
        const districtRes = await dispatch(
          getDistricSlice({ token, stateId: matchedState._id }),
        ).unwrap();
        const matchedDistrict = districtRes?.result?.list?.find(
          (d) =>
            d.name.toLowerCase().trim() ===
            userDetails?.districtName?.toLowerCase().trim(),
        );
        if (!matchedDistrict) return;

        setFormData((prev) => ({
          ...prev,
          district: matchedDistrict._id,
          districtName: matchedDistrict.name,
        }));
        const cityRes = await dispatch(
          getCitySlice({
            token,
            countryId: matchedCountry._id,
            stateId: matchedState._id,
            districtId: matchedDistrict._id,
          }),
        ).unwrap();

        // if (userDetails?.cityName) {
        //   const matchedCity = cityRes?.result?.list?.find(
        //     (c) =>
        //       c.name.toLowerCase().trim() ===
        //       userDetails.cityName.toLowerCase().trim()
        //   );
        //   if (matchedCity) {
        //     setFormData((prev) => ({
        //       ...prev,
        //       city: matchedCity._id,
        //       cityName: matchedCity.name,
        //     }));
        //   } else {
        //     setFormData((prev) => ({
        //       ...prev,
        //       cityName: userDetails.cityName,
        //     }));
        //   }
        // }

        if (userDetails?.address) {
          const addressLower = userDetails.address.toLowerCase();
          const addressWords = addressLower.split(/[\s,/]+/).reverse();
          const cityNameMap = new Map();
          cityRes?.result?.list?.forEach((city) => {
            cityNameMap.set(city.name.toLowerCase().trim(), city);
          });
          let matchedCity = null;
          for (const word of addressWords) {
            if (cityNameMap.has(word)) {
              matchedCity = cityNameMap.get(word);
              break;
            }
          }

          if (matchedCity) {
            setFormData((prev) => ({
              ...prev,
              city: matchedCity._id,
              cityName: matchedCity.name,
            }));
          } else {
            setFormData((prev) => ({
              ...prev,
              cityName: userDetails.cityName,
            }));
          }
        }
      } catch (error) {
        console.error("Error during form prefill:", error);
      }
    };
    prefillForm();
  }, [userDetails, aadharNumber, dispatch, setFormData, token]);

  useEffect(() => {
    if (isUpdateMode || !aadharNumber) return;

    setFormData((prev) => ({
      ...prev,
      aadhar_number: prev.aadhar_number || aadharNumber,
    }));
  }, [aadharNumber, isUpdateMode, setFormData]);

  return (
    <>
      <Modal
        show={modalVisible}
        onHide={() => {
          resetForm();
          dispatch({ type: "CLEAR_USER_DETAILS" });
          setModalVisible(false);
        }}
        size={"xl"}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {isUpdateMode ? "Update Patient" : "Add Patient"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleAddPatient}>
            <div className="row">
              <div className="col-xl-4">
                <InputName
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  label="Name *"
                  setInputNameError={setInputError}
                  required={true}
                  fieldName="Patient Name"
                  showTitle={true}
                  title={formData.title}
                  onTitleChange={handleChange}
                />
              </div>
              <div className="col-xl-4">
                <InputEmail
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  label="Email"
                  setInputEmailError={setInputError}
                  required={false}
                />
              </div>
              <div className="col-xl-4">
                <InputNumber
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  label="Mobile *"
                  setInputNumberError={setInputError}
                />
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <InputImage
                    name="patient_image"
                    onChange={handleFileChange}
                    label="Patient Photo"
                    setInputImgError={setInputError}
                    value={formData?.patient_image}
                    multiple={false}
                    required={false}
                    minSize={10 * 1024}
                    maxSize={1 * 1024 * 1024}
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <InputNumber
                  name="alternate_Phone"
                  value={formData.alternate_Phone}
                  onChange={handleChange}
                  label="Alternate Mobile"
                  setInputNumberError={setInputError}
                  required={false}
                />
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label className="col-form-label">Gender *:</label>
                  <Select
                    name="gender"
                    value={
                      formData.gender
                        ? {
                            value: formData.gender,
                            label: formData.gender,
                          }
                        : null
                    }
                    placeholder="Select Gender"
                    onChange={(selectedOption) => {
                      handleSelectChange(selectedOption, "gender");
                      setFieldErrors((prev) => ({ ...prev, gender: "" }));
                    }}
                    options={genderOptions}
                  />
                  {fieldErrors.gender && (
                    <p className="text-danger small mt-1">
                      {fieldErrors.gender}
                    </p>
                  )}
                </div>
              </div>
              <InputDobOrAge
                dob={formData?.dob}
                age={formData?.age}
                onChange={handleChange}
                dobSize="col-xl-4"
                ageSize="col-xl-4"
              />
              <div className="col-xl-4">
                <div className="form-group">
                  <label htmlFor="message-text" className="col-form-label">
                    Blood Group:
                  </label>
                  <Select
                    name="blood_group"
                    value={
                      formData.blood_group
                        ? {
                            value: formData.blood_group,
                            label: formData.blood_group,
                          }
                        : null
                    }
                    placeholder="Select Blood Group"
                    onChange={(selectedOption) =>
                      handleSelectChange(selectedOption, "blood_group")
                    }
                    options={bloodGroupOptions}
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label className="col-form-label">Country *</label>
                  <Select
                    name="country"
                    value={
                      formData?.country
                        ? {
                            value: formData?.country,
                            label: formData?.countryName,
                          }
                        : null
                    }
                    placeholder="Select country"
                    onChange={(selectedOption) => {
                      handleSelectChange(selectedOption, "country");
                      setFieldErrors((prev) => ({ ...prev, country: "" }));
                    }}
                    options={Country?.map((item) => ({
                      value: item._id,
                      label: item.name,
                    }))}
                  />
                  {fieldErrors.country && (
                    <p className="text-danger small mt-1">
                      {fieldErrors.country}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label className="col-form-label">State*</label>
                  <Select
                    name="state"
                    value={
                      formData?.state
                        ? { value: formData?.state, label: formData?.stateName }
                        : null
                    }
                    placeholder="Select state"
                    onChange={(selectedOption) => {
                      handleSelectChange(selectedOption, "state");
                      setFieldErrors((prev) => ({ ...prev, state: "" }));
                    }}
                    options={state?.map((item) => ({
                      value: item?._id,
                      label: item?.name,
                    }))}
                  />
                  {fieldErrors?.state && (
                    <p className="text-danger small mt-1">
                      {fieldErrors.state}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label className="col-form-label">District*</label>
                  <Select
                    name="district"
                    value={
                      formData?.district
                        ? {
                            value: formData.district,
                            label: formData.districtName,
                          }
                        : null
                    }
                    placeholder="Select district"
                    onChange={(selectedOption) => {
                      handleSelectChange(selectedOption, "district");
                      setFieldErrors((prev) => ({ ...prev, district: "" }));
                    }}
                    options={districts?.map((item) => ({
                      value: item?._id,
                      label: item?.name,
                    }))}
                  />
                  {fieldErrors?.district && (
                    <p className="text-danger small mt-1">
                      {fieldErrors.district}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label className="col-form-label">City*</label>
                  <Select
                    name="city"
                    value={
                      formData?.city
                        ? { value: formData.city, label: formData.cityName }
                        : null
                    }
                    placeholder="Select city"
                    onChange={(selectedOption) => {
                      handleSelectChange(selectedOption, "city");
                      setFieldErrors((prev) => ({ ...prev, city: "" }));
                    }}
                    options={cities?.map((item) => ({
                      value: item?._id,
                      label: item?.name,
                    }))}
                  />
                  {fieldErrors?.city && (
                    <p className="text-danger small mt-1">{fieldErrors.city}</p>
                  )}
                </div>
              </div>
              <div className="col-xl-4">
                <InputText
                  name="address"
                  value={formData?.address}
                  onChange={handleChange}
                  label="Address"
                  setInputTextError={setInputError}
                  required={false}
                  placeholder="Enter Address"
                  readOnly={false}
                />
              </div>
              <div className="col-md-4">
                <InputPINCode
                  name="pin"
                  value={formData?.pin}
                  onChange={handleChange}
                  label="Pincode"
                  setInputPINCodeError={setInputError}
                />
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label htmlFor="message-text" className="col-form-label">
                    HC Number:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="HC Number"
                    onChange={handleChange}
                    name="HC_number"
                    value={formData.HC_number}
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <InputPassport
                  name="passport"
                  value={formData.passport}
                  onChange={handleChange}
                  label="Passport"
                  setInputPassportError={setInputError}
                />
              </div>
              <div className="col-xl-4">
                <InputAdhar
                  name="aadhar_number"
                  value={formData.aadhar_number}
                  onChange={handleChange}
                  label="AADHAR"
                  setInputAdharError={setInputError}
                />
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label htmlFor="message-text" className="col-form-label">
                    Membership Group:
                  </label>
                  <Select
                    name="membership_group"
                    value={
                      formData.membership_group
                        ? {
                            value: formData.membership_group,
                            label: formData.membership_group,
                          }
                        : null
                    }
                    placeholder="Select Membership"
                    onChange={(selectedOption) =>
                      handleSelectChange(selectedOption, "membership_group")
                    }
                    options={membershipOptions}
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <InputText
                  name="abhaNumber"
                  value={formData.abhaNumber}
                  onChange={handleChange}
                  label="Abha Number"
                  setInputNumberError={setInputError}
                />
              </div>
              <div className="col-xl-4">
                <InputText
                  name="abhaAddress"
                  value={formData.abhaAddress}
                  onChange={handleChange}
                  label="Abha Address"
                  setInputNameError={setInputError}
                  fieldName="Abha Address"
                />
              </div>
            </div>
            <div className="text-end">
              <Button
                variant="secondary"
                onClick={() => {
                  resetForm();
                  dispatch({ type: "CLEAR_USER_DETAILS" });
                  setModalVisible(false);
                }}
                className="me-4 p-2"
              >
                Cancel
              </Button>
              <Button variant="primary" type="submit" className="p-2">
                {isUpdateMode ? "Update" : "Add"}
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddUpdateModal;
